const e="undefined"!=typeof window;export{e as isBrowser};
//# sourceMappingURL=isBrowser.js.map
